@if (formPlanner) {
  <div class="box p-2" [formGroup]="formPlanner">
    <app-select
      class="w-100 pb-3"
      optionValue="value"
      optionLabel="name"
      label="{{ 'chose_days' | translate }}"
      [options]="days"
      [type]="SelectType.Multiple"
      [showClear]="true"
      [maxSelectedLabels]="3"
      [isTranslate]="true"
      [formControl]="formPlanner.controls.days"
    />
    <mat-form-field appearance="outline">
      <mat-label>{{ 'from' | translate }}</mat-label>
      <input
        matInput
        mask="Hh:m0"
        [formControl]="formPlanner.controls.from"
        [showMaskTyped]="true"
        [dropSpecialCharacters]="false"
        [shownMaskExpression]="'__:__'"
      />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'to' | translate }}</mat-label>
      <input
        matInput
        mask="Hh:m0"
        [formControl]="formPlanner.controls.to"
        [showMaskTyped]="true"
        [dropSpecialCharacters]="false"
        [shownMaskExpression]="'__:__'"
      />
    </mat-form-field>
    <app-checkbox [formControl]="formPlanner.controls.is_all_day" (change)="clickIsDay()" class="checkbox">
      {{ 'work_all_day' | translate }}
    </app-checkbox>
    <div class="d-flex gap-2 align-self-end">
      <!--    <app-button btnType="cancel" (onChangeClick)="onClose()">{{ 'cancel' | translate }}</app-button>-->
      <app-button (onChangeClick)="onSave()">{{ 'save' | translate }}</app-button>
    </div>
  </div>
}
